import { get, post, put, del } from './api';

// Create a new role
export const createRole = (data) => {
  return post('/roles', data);
};

// Get all roles with pagination
export const getAllRoles = (page = 1) => {
  return get(`/roles?page=${page}`);
};

// Get a role by ID
export const getRoleById = (id) => {
  return get(`/roles/${id}`);
};

// Update a role
export const updateRole = (id, data) => {
  return put(`/roles/${id}`, data);
};

// Delete a role (soft delete if your backend supports it)
export const deleteRole = (id) => {
  return del(`/roles/${id}`);
};
